// extracted by mini-css-extract-plugin
export default {"ContainerPreescalera":"Preescalera_ContainerPreescalera__-4G8m"};